import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const USERS_SUCCESS = 'FETCH_USERS_SUCCESS';

export const fetchUsers = () => {
    return function(dispatch) {
        dispatch(fetchUsersRequest());
        return axios(apiRequestOptions(apiPath.USER.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchUsersSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchUsersFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchUsersRequest = () => ({ type: USERS_REQUEST });

const fetchUsersFailure = (error) => ({ type: USERS_FAILURE, error });

const fetchUsersSuccess = (data) => ({ type: USERS_SUCCESS, data });
